import { render, staticRenderFns } from "./Trips.vue?vue&type=template&id=a916f242&scoped=true"
import script from "./Trips.vue?vue&type=script&lang=js"
export * from "./Trips.vue?vue&type=script&lang=js"
import style0 from "./Trips.vue?vue&type=style&index=0&id=a916f242&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a916f242",
  null
  
)

export default component.exports